/* 账单只读详情*/
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Button,
  Space,
  message,
} from "antd";
import { HomeOutlined , CheckOutlined, } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import moment from "moment";
import { CustomUpload } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const UtilityPaymentModalAdd = ({
  addopen,
  handleModalSubmitlFn,
  handleModalCancelFn,
  form,
  formTenant,
  record,
}) => {
    const [invTenantValue, setInvTenantValue] = useState(null);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [formOptions, setFormOptions] = useState({
      tenantOptions: [],
      serviceCodeOptions: [],
    });
    const [filePaths, setFilePaths] = useState([]);
    useEffect(() => {
      if(!addopen) {
        setFilePaths([])
        form.resetFields();
        submitBtnRef?.current?.setLoading(false)
        setBtnDisabled(false);
        formTenant.resetFields();
      }else{
        console.log(record,'===record===AddModal');
        form.setFieldsValue({ ...record })
        formTenant.setFieldsValue({ ...record })
        setInvTenantValue(record?.invoiceTenant === "1")
        if(record?.invoiceTenant === "1"){
          getTenantData()
        }
      }
    },[addopen])

    // 获取Tenant和Service Code
    const getTenantData = async () => {
      const { propId, unitId, vendorUtilPaymentId } = record
      const response = await http.get(api.Tenant, {params: {propId, unitId, vendorUtilPaymentId}});
      let invoiceTenantDate = record?.invoiceTenantDate
      if(!record?.invoiceTenantDate){
        const cDate = await http.get(api.commonCurrentDate)
        invoiceTenantDate = cDate && dayjs(cDate) || undefined
      }
      const tenantOptions = (response?.optTenant || []).map((item, index) => ({
        value: item.tenantId,
        label: item.tenantStatus,
        moveInDate: item.moveInDate,
      }));

      const serviceCodeOptions = Object.entries(response?.serviceCodes || {}).map(([value, label]) => ({
        value,
        label,
      }));
      setFormOptions({
        tenantOptions,
        serviceCodeOptions
      })
      formTenant.setFieldsValue({ unitIdTemp: response?.unit, invTenantId: response?.tenantId || undefined, serviceCode: response?.serviceCodeId || undefined, invoiceTenantDate });
    }

    const testFn = async (values) => {
      // 获取 formTenant 的值
      const formData = form.getFieldsValue();
      console.log("====formData", formData);
      const tenantValues = formTenant.getFieldsValue();
      console.log("====tenantValues", tenantValues);
  
    }

    const submitFn = async () => {
      form.validateFields().then(val => {
        const values = form.getFieldsValue()
        const {foreignId, glAcct, propId, trustId, bank, bankId, vendorId, unitId, vendorPaymentId } = record
        let params = {
          ...values,
          vendid: record.vendid,
          foreignId,
          glAcct,
          propId,
          trustId,
          bank,
          bankId,
          vendorId,
          unitId,
          vendorPaymentId,
          uuidList: filePaths.map(item => item.uuid),
          // filePaths: filePaths.filter(item => !item.fileUploadId),
          // glAcctMulti: [],
          glAcct: record.glAcctMulti,
          invoiceDateStr: values.invoiceDate && values.invoiceDate.format('YYYY-MM-DD') || '',
          serviceStartDateStr: values.serviceStartDate && values.serviceStartDate.format('YYYY-MM-DD') || '',
          serviceEndDateStr: values.serviceEndDate && values.serviceEndDate.format('YYYY-MM-DD') || '',
        }
        if(invTenantValue){
          formTenant.validateFields().then(tenantVal => {
            if(tenantVal){
              params = {
                ...tenantVal,
                ...params,
                invoiceTenantDateStr: tenantVal.invoiceTenantDate && tenantVal.invoiceTenantDate.format('YYYY-MM-DD') || '',
              }
              submitTempFn(params)
            }
          }).catch(err =>{
            console.log(err,'===err');
          })
        }else{
          params = {
            ...params,
            // ...formTenantData,
          }
          submitTempFn(params)
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }
    const submitTempFn = async(values) => {
      submitBtnRef?.current?.setLoading(true)
      const response = await http.post(api.ApprovalAdd, values);
      // 判断 `code` 是否为 '1' 表示成功
      if (response.code === "1") {
        message.success("Added successfully"); // 成功提示
        handleModalSubmitlFn();
      } else {
        message.error(response.msg);
      }
      submitBtnRef?.current?.setLoading(false)
    }
  const dueDateChange = () => {
    console.log("dueDateChange");
  };

  const invTenantValueChangeFn = (value) => {
    setInvTenantValue(value === '1')
    if(value === '1'){
      getTenantData()
    } else {
      setFormOptions({
        tenantOptions: [],
        serviceCodeOptions: []
      })
      formTenant.setFieldsValue({ unitIdTemp: undefined, invTenantId: undefined, serviceCode: undefined, invoiceTenantDate: undefined });
    }
  }

  const invRemarkFn = () => {
    const formData = form.getFieldsValue();
    const formTenantData = formTenant.getFieldsValue();
    if(formTenantData['serviceCode']){
      const label = formOptions.serviceCodeOptions.find(item => item.value === formTenantData['serviceCode'])?.label
      const first = label?.split("-")?.[1]?.trim()
      const date = (formData?.serviceStartDate && formData?.serviceEndDate) ? (moment(formData.serviceEndDate).format("MM/DD/YYYY") + "-" + moment(formData.serviceEndDate).format("MM/DD/YYYY")): ''
      formTenant.setFieldsValue({"invRemark": `${first} ${date}`})
    }
  }

  const invoiceCommonFn = ({ amount, serviceStartDate, serviceEndDate, invTenantId }) => {
    const startDate = serviceStartDate && new Date(serviceStartDate) || undefined;
    const endDate = serviceEndDate && new Date(serviceEndDate) || undefined;
    const moveInDateTemp = invTenantId && formOptions.tenantOptions.find(item => item.value === invTenantId).moveInDate || undefined;
    const moveInDate = moveInDateTemp && new Date(moveInDateTemp) || undefined;
    let tenantDays = 0;
    let tenantAmount = '';
    
    const showFlag = !!(startDate && endDate && moveInDate)
    const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
    const dailyAmount =  amount / totalDays;
    const payByFlag = record?.payBy === 'Tenant'
    const flag1 = moveInDate < startDate
    const flag2 = moveInDate > endDate
    const flag3 = !flag1 || !flag2
    return {
      tenantDays,
      startDate,
      endDate,
      moveInDate,
      tenantAmount,
      showFlag,
      totalDays,
      dailyAmount,
      payByFlag,
      flag1,
      flag2,
      flag3,
    }
  }

  const InvoiceCalculationRuleDoc =  React.memo(() => {
    const amount = Form.useWatch('amount', form)
    const serviceStartDate = Form.useWatch('serviceStartDate', form)
    const serviceEndDate = Form.useWatch('serviceEndDate', form)
    const invTenantId = Form.useWatch('invTenantId', formTenant)
    const [calcData, setCalcData] = useState({});

    useEffect(() => {
      const data = invoiceCommonFn({
        amount, serviceStartDate, serviceEndDate, invTenantId, record
      });
      setCalcData(data);
    }, [amount, serviceStartDate, serviceEndDate, invTenantId]);
    let {
      tenantDays, startDate, endDate, moveInDate, tenantAmount,
      showFlag, totalDays, dailyAmount, payByFlag, flag1
    } = calcData || {};

    if (moveInDate < startDate) {
      tenantAmount = payByFlag ? '' : (dailyAmount * totalDays).toFixed(2);
      tenantDays = payByFlag ? 0 : totalDays;
    } else if (moveInDate > endDate) {
      tenantDays = 0;
      tenantAmount = '';
    } else {
      tenantDays = Math.ceil((endDate - moveInDate) / (1000 * 60 * 60 * 24)) + 1;
      tenantAmount = (dailyAmount * tenantDays).toFixed(2);
    }
    if(showFlag && !record?.vendorPaymentId){
      formTenant.setFieldsValue({invAmount: tenantAmount})
    }

    if (!["Tenant", "Owner Invoice Tenant"].includes(record?.payBy) || !showFlag) return null;

    const dynamicTableCss = {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      color: '#333',
      backgroundColor: '#f9f9f9',
      border: '2px solid #02c0ef',
      borderRadius: '12px',
      width: '100%',
      padding: '20px 30px',
      marginTop: '15px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
    }
    const titleCss = {
      backgroundColor: '#02c0ef',
      color: 'white',
      fontSize: '18px',
      fontWeight: 'bold',
      textAlign: 'center',
      padding: '6px',
      borderRadius: '10px',
      marginBottom: '15px',
    }
    const contentCss = {
      margin: '8px 0',
      fontSize: '16px',
      fontWeight: 'bold',
    }

    const list = [
      {
        title: 'Pay By:',
        value: record.payBy,
      },
      {
        title: 'Service Days:',
        value: totalDays,
      },
      {
        title: 'Invoice Amount / Day:',
        value: dailyAmount.toFixed(2),
      },
      {
        title: 'Invoice Service Days:',
        value: tenantDays,
      },
      {
        title: 'Invoice Tenant Amount:',
        value: tenantAmount,
      }
    ]
    return (
      <div style={{ ...dynamicTableCss }}>
        <div style={{ ...titleCss }}>Invoice Calculation Rule</div>
        {(flag1 && payByFlag) ? 
          (<div style={{ ...contentCss }}>This bill is fully paid by the tenant, so you do not need to add a new payment.</div>) :
          (<>
            {list.map(item => <p style={{...contentCss, fontWeight: 'normal'}}><strong>{ item.title }</strong> {item.value}</p>)}
          </>
          )
        }
      </div>
    )
  })

  const submitBtnRef = useRef();

  const SubmitBtn =  React.memo(forwardRef(({}, ref) => {
    const [btnLoading, setBtnLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      setLoading: (loading) => setBtnLoading(loading),
    }));

    if (record?.printedMsg || record?.noSubmitBtn) {
      return null;
    }
    return (
      <Button type="primary" onClick={submitFn} loading={btnLoading} disabled={btnDisabled}>
        submit
      </Button>
    )
  }))

  return (
    <Modal
          title={
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
              <HomeOutlined style={{ marginRight: "8px" }} />
              { record?.color == "#dd4b39" ? 'View Payment History' : 'EDIT PAYMENT' }
              <div
                style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
              ></div>
            </div>
          }
          centered
          open={addopen}
          onCancel={() => handleModalCancelFn()}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          width="80%"
        >
          <Form
            form={form}
            layout="horizontal"
            labelCol={{span: 8}}
            wrapperCol={{span: 16}}
            labelWrap={true}
            labelAlign="right"
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Account & Meter Infomation
                </div>
                <Form.Item name="propName" label="Prop" rules={[{ required: true }]}>
                  <Input.TextArea
                    placeholder="Search street"
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item
                  name="vendorName"
                  label="Vendor"
                  rules={[{ required: true }]}
                >
                  <Input.TextArea
                    placeholder="Search street"
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item
                  name="remark"
                  label="Check Memo"
                  rules={[{ required: true }]}
                >
                  <Input.TextArea
                    placeholder="Search street"
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item
                  name="customerAccount"
                  label="Customer Number"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="gasMeter" label="Gas Meter #">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="gasRemark" label="Gas Remark">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="waterMeter" label="Water Meter #">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="waterRemark" label="Water Remark">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="electricMeter" label="Electric Meter #">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
  
                <Form.Item name="electricRemark" label="Electric Remark">
                  <Input
                    disabled
                    style={{
                      color: "rgba(0, 0, 0, 0.85)",
                      backgroundColor: "#d2d6de",
                      cursor: "not-allowed",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Payment Information
                </div>
                {record?.printedMsg && <div
                  style={{
                    backgroundColor: '#00a65a',
                    color: '#fff',
                    borderColor: '#008d4c',
                    marginBottom: "16px",
                    borderRadius: '3px',
                    padding: '15px 35px 15px 15px',
                    marginBottom: '20px',
                    border: '1px solid transparent',
                    textAlign: 'center',
                  }}
                >
                  <div style={{ fontSize: '18px',fontWeight: 600, marginTop: 0, marginBottom: '10px' }}>
                    { record?.color != '#f39c12' && <CheckOutlined style={{ marginRight: "8px", fontSize: '20px' }} /> || null}
                    <span style={{ textAlign: 'left'}}>{ record.printedMsg }</span>
                  </div>
                </div> || null}
                <Form.Item
                  name="invoiceDate"
                  label="Invoice Date"
                  rules={[{ required: true, message: "Invoice Date is required!" }]}
                >
                  <DatePicker
                    style={{
                      width: "100%",
                    }}
                    format={['MM/DD/YYYY', "M/D/YYYY"]}
                    onChange={dueDateChange}
                  />
                </Form.Item>
  
                <Form.Item name="usid" label="Usid" rules={[{ required: true, message: "Usid is required!" }]}>
                  <Input disabled style={{ color: 'rgba(0, 0, 0, 0.85)', backgroundColor: '#d2d6de', cursor: 'not-allowed' }} />
                </Form.Item>
  
                {commonFn.formInputNumberDoc({
                    form,
                    validator: (_, value, callback) => {
                      if(value >= 100000){
                        callback('The Amount Must Be Between 0 And 100000.')
                      } else {
                        callback()
                      }
                    }
                  })
                }
  
                <Form.Item
                  name="serviceStartDate"
                  label="Service Start Date"
                >
                  <DatePicker
                    onChange={()=> invRemarkFn()}
                    style={{
                      width: "100%",
                    }}
                    format={['MM/DD/YYYY', "M/D/YYYY"]}
                  />
                </Form.Item>
  
                <Form.Item
                  name="serviceEndDate"
                  label="Service End Date"
                >
                  <DatePicker
                    onChange={()=> invRemarkFn()}
                    style={{
                      width: "100%",
                    }}
                    format={['MM/DD/YYYY', "M/D/YYYY"]}
                  />
                </Form.Item>
  
                <Form.Item
                  name="invoiceTenant"
                  label="Invoice Tenant"
                  rules={[{ required: true, message: "Invoice Tenant is required!" }]}
                >
                  <Select
                    showSearch
                    placeholder="Select a type"
                    onChange={invTenantValueChangeFn}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "1",
                        label: "Yes",
                      },
                      {
                        value: "0",
                        label: "No",
                      },
                    ]}
                  />
                </Form.Item>
                {invTenantValue && (
                  <>
                    <Form
                      form={formTenant}
                      layout="horizontal"
                      labelCol={{span: 8}}
                      wrapperCol={{span: 16}}
                      labelWrap={true}
                      labelAlign="right"
                      onFinish={(values) => {
                        console.log("Form Values:", values);
                      }}
                    >
                      <Form.Item name="unitIdTemp" label="Unit">
                        <Input disabled />
                      </Form.Item>
  
                      {/* optTenant 下拉框 */}
                      <Form.Item 
                        label="Tenant" 
                        name="invTenantId"
                        rules={[{ required: true, message: "Tenant is required!"}]}
                      >
                        <Select placeholder="Select a tenant">
                          {formOptions.tenantOptions.map((option) => (
                            <Select.Option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name="invoiceTenantDate"
                        label="Invoice Tenant Date"
                        rules={[{ required: true, message: "Invoice Tenant Date is required!"}]}
                      >
                        <DatePicker
                          style={{
                            width: "100%",
                          }}
                          format={['MM/DD/YYYY', "M/D/YYYY"]}
                          onChange={dueDateChange}
                        />
                      </Form.Item>
  
                      {commonFn.formInputNumberDoc({
                        name: 'invAmount', 
                        label: 'Invoice Amount',
                        form: formTenant,
                        validator: (_, value, callback) => {
                          if(value >= 100000){
                            callback('The Amount Must Be Between 0 And 100000.')
                          } else {
                            callback()
                          }
                        }
                      })}
                      <Form.Item 
                        label="Service Code" 
                        name="serviceCode"
                        rules={[{ required: true, message: "Service Code is required!"}]}
                      >
                        <Select placeholder="Select a service code" onSelect={() => invRemarkFn()}>
                          {formOptions.serviceCodeOptions.map((option) => (
                            <Select.Option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
  
                      <Form.Item
                        name="invRemark"
                        label="Invoice Remark"
                        rules={[
                          {
                            required: true,
                            message: "Please enter the Invoice Remark!",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Form>
                  </>
                )}

                <Form.Item className="btnCenter">
                  <Space align="center">
                    {/* <Button key="back" onClick={testFn}>
                      TEST
                    </Button> */}
                    <Button onClick={() => handleModalCancelFn()}>
                      cancel
                    </Button>
                    <SubmitBtn ref={submitBtnRef} />
                  </Space>
                </Form.Item>
                
                <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} label={null}>
                  <InvoiceCalculationRuleDoc />
                </Form.Item>
              </Col>
  
              <Col span={8}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Upload PDF image
                </div>
                <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="uploadFile" label={null}>
                  <CustomUpload 
                    setFilePaths={setFilePaths} 
                    filePaths={filePaths} 
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isEdit={record?.isEdit}
                    vendorPaymentId={record?.vendorPaymentId || undefined}
                    foreignId={record?.vendorUtilPaymentId || undefined}
                    type={record?.type || 'util_payment'}
                    customConfig={{
                      accept: ".jpg, .jpeg, .png, .pdf",
                      disabled: record?.noSubmitBtn || false
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
  );
};

export default UtilityPaymentModalAdd;
